import { render } from "./TheListItemIndexPage.vue?vue&type=template&id=37e8fbc0&class=px-1.5"
import script from "./TheListItemIndexPage.vue?vue&type=script&lang=js"
export * from "./TheListItemIndexPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__